import { graphql, Link, useStaticQuery } from "gatsby";
import React, { useState } from "react";
import MenuMobile from "./MenuMobile/MenuMobile";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { site } = useStaticQuery(graphql`
    query {
      site {
        data: siteMetadata {
          menu {
            name
            to
          }
        }
      }
    }
  `);
  return (
    <nav className="container px-4 sm:px-6 lg:px-8">
      <div className="py-6 md:py-7 relative">
        <div className="absolute inset-y-0 -left-[100vw] -right-[100vw] z-0 border-b border-gray-200 bg-white/80 backdrop-blur-md" />
        <div className="block sm:hidden flex justify-between items-center relative z-10">
          <Link
            to="/"
            className="text-base font-semibold text-gray-900 tracking-tight hover:text-gray-700 transition-colors duration-200"
          >
            Daniel Martin
          </Link>
          <button
            type="button"
            className="p-2 -mr-2 text-gray-700 hover:text-gray-900 transition-colors duration-200"
            onClick={() => setIsMenuOpen(true)}
            aria-label="Open menu"
          >
            <svg
              className="w-6 h-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h7"
              />
            </svg>
          </button>
        </div>
        <div className="hidden sm:flex justify-between items-center relative z-10">
          <Link
            to="/"
            className="text-base font-semibold text-gray-900 tracking-tight hover:text-gray-700 transition-colors duration-200"
          >
            Daniel Martin
          </Link>
          <div className="flex items-center gap-8">
            {site.data.menu.map(({ name, to }, key) =>
              to !== "/" ? (
                <Link
                  to={to}
                  key={`desktop-nav-${key}`}
                  className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors duration-200"
                >
                  {name}
                </Link>
              ) : null
            )}
          </div>
        </div>
        <MenuMobile
          isOpen={isMenuOpen}
          setIsOpen={setIsMenuOpen}
          links={site.data.menu}
        />
      </div>
    </nav>
  );
};

export default Header;
